import PerfectScrollbar from 'react-perfect-scrollbar';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { toggleSidebar } from '@/store/themeConfigSlice';
import { IRootState } from '@/store';
import { usePermission } from '@/hooks/usePermission';

interface NavItem {
    to: string;
    label: string;
    end?: boolean;
    permission?: string;
    anyOf?: string[];
    icon: JSX.Element;
}

const NAV_ITEMS: NavItem[] = [
    {
        to: '/apps',
        label: 'Aplicativos',
        permission: 'apps.view',
        icon: (
            <svg className="group-hover:!text-primary shrink-0" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    opacity="0.5"
                    d="M2 12.2039C2 9.91549 2 8.77128 2.5192 7.82274C3.0384 6.87421 3.98695 6.28551 5.88403 5.10813L7.88403 3.86687C9.88939 2.62229 10.8921 2 12 2C13.1079 2 14.1106 2.62229 16.116 3.86687L18.116 5.10812C20.0131 6.28551 20.9616 6.87421 21.4808 7.82274C22 8.77128 22 9.91549 22 12.2039V13.725C22 17.6258 22 19.5763 20.8284 20.7881C19.6569 22 17.7712 22 14 22H10C6.22876 22 4.34315 22 3.17157 20.7881C2 19.5763 2 17.6258 2 13.725V12.2039Z"
                    fill="currentColor"
                />
                <path
                    d="M9 17.25C8.58579 17.25 8.25 17.5858 8.25 18C8.25 18.4142 8.58579 18.75 9 18.75H15C15.4142 18.75 15.75 18.4142 15.75 18C15.75 17.5858 15.4142 17.25 15 17.25H9Z"
                    fill="currentColor"
                />
            </svg>
        ),
    },
    {
        to: '/titulos',
        label: 'Títulos',
        permission: 'titulos.view',
        icon: (
            <svg className="group-hover:!text-primary shrink-0" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    opacity="0.5"
                    d="M8 2H16C18.8284 2 20.2426 2 21.1213 2.87868C22 3.75736 22 5.17157 22 8V16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H8C5.17157 22 3.75736 22 2.87868 21.1213C2 20.2426 2 18.8284 2 16V8C2 5.17157 2 3.75736 2.87868 2.87868C3.75736 2 5.17157 2 8 2Z"
                    fill="currentColor"
                />
                <path d="M7 10C7 9.44772 7.44772 9 8 9H16C16.5523 9 17 9.44772 17 10C17 10.5523 16.5523 11 16 11H8C7.44772 11 7 10.5523 7 10Z" fill="currentColor" />
                <path d="M7 14C7 13.4477 7.44772 13 8 13H13C13.5523 13 14 13.4477 14 14C14 14.5523 13.5523 15 13 15H8C7.44772 15 7 14.5523 7 14Z" fill="currentColor" />
            </svg>
        ),
    },
    {
        to: '/elite',
        label: 'Elite',
        anyOf: ['elite.access', 'elite.view_global'],
        icon: (
            <svg className="group-hover:!text-primary shrink-0" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    opacity="0.5"
                    d="M17.7805 11L19.7126 4.03361C19.8733 3.45419 19.3485 2.91933 18.7633 3.07266L15.5436 3.91629C14.9796 4.06406 14.3872 3.81486 14.093 3.30618L12.7572 0.996604C12.4193 0.412457 11.5807 0.412457 11.2428 0.996604L9.90704 3.30618C9.61283 3.81486 9.02041 4.06406 8.45638 3.91629L5.23671 3.07266C4.65151 2.91933 4.12667 3.45419 4.28744 4.03361L6.21951 11H17.7805Z"
                    fill="currentColor"
                />
                <path d="M6 13V18.5C6 20.4330 7.567 22 9.5 22H14.5C16.433 22 18 20.433 18 18.5V13H6Z" fill="currentColor" />
            </svg>
        ),
    },
    {
        to: '/marketing',
        label: 'Marketing',
        permission: 'marketing.view',
        icon: (
            <svg className="group-hover:!text-primary shrink-0" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.5" d="M18 8.5L20.5 6V18L18 15.5V8.5Z" fill="currentColor" />
                <path
                    d="M3 10C3 8.34315 4.34315 7 6 7H14C15.6569 7 17 8.34315 17 10V14C17 15.6569 15.6569 17 14 17H10.5L8.5 20.5C8.27 20.9 7.73 20.9 7.5 20.5L6 17.9C4.3 17.6 3 16.1 3 14.3V10Z"
                    fill="currentColor"
                />
            </svg>
        ),
    },
    {
        to: '/admin',
        label: 'Administração',
        anyOf: ['users.manage', 'roles.manage', 'sectors.manage', 'audit.view'],
        icon: (
            <svg className="group-hover:!text-primary shrink-0" width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                    opacity="0.5"
                    d="M20.7906 8.121L20.1006 6.931C19.7306 6.291 19.5406 5.971 19.2206 5.861C18.9006 5.751 18.5306 5.891 17.7906 6.171L16.2406 6.761C15.6306 6.531 14.9906 6.361 14.3306 6.261L13.6306 4.8C13.2906 4.1 13.1206 3.751 12.8206 3.551C12.5206 3.351 12.1406 3.351 11.3806 3.351H10.6206C9.86056 3.351 9.48056 3.351 9.18056 3.551C8.88056 3.751 8.71056 4.1 8.37056 4.8L7.67056 6.261C7.01056 6.361 6.37056 6.531 5.76056 6.761L4.21056 6.171C3.47056 5.891 3.10056 5.751 2.78056 5.861C2.46056 5.971 2.27056 6.291 1.90056 6.931L1.21056 8.121C0.83056 8.771 0.64056 9.101 0.69056 9.421C0.74056 9.741 1.01056 10.011 1.55056 10.551L2.58056 11.551C2.53056 11.901 2.50056 12.2511 2.50056 12.601C2.50056 12.9511 2.53056 13.3011 2.58056 13.6511L1.55056 14.651C1.01056 15.191 0.74056 15.461 0.69056 15.781C0.64056 16.101 0.83056 16.431 1.21056 17.081L1.90056 18.271C2.27056 18.911 2.46056 19.231 2.78056 19.341C3.10056 19.451 3.47056 19.311 4.21056 19.031L5.76056 18.441C6.37056 18.671 7.01056 18.841 7.67056 18.941L8.37056 20.401C8.71056 21.101 8.88056 21.451 9.18056 21.651C9.48056 21.851 9.86056 21.851 10.6206 21.851H11.3806C12.1406 21.851 12.5206 21.851 12.8206 21.651C13.1206 21.451 13.2906 21.101 13.6306 20.401L14.3306 18.941C14.9906 18.841 15.6306 18.671 16.2406 18.441L17.7906 19.031C18.5306 19.311 18.9006 19.451 19.2206 19.341C19.5406 19.231 19.7306 18.911 20.1006 18.271L20.7906 17.081C21.1706 16.431 21.3606 16.101 21.3106 15.781C21.2606 15.461 20.9906 15.191 20.4506 14.651L19.4206 13.6511C19.4706 13.3011 19.5006 12.9511 19.5006 12.601C19.5006 12.2511 19.4706 11.901 19.4206 11.551L20.4506 10.551C20.9906 10.011 21.2606 9.741 21.3106 9.421C21.3606 9.101 21.1706 8.771 20.7906 8.121Z"
                    fill="currentColor"
                />
                <path
                    d="M11.0005 15.5C12.9335 15.5 14.5005 13.933 14.5005 12C14.5005 10.067 12.9335 8.5 11.0005 8.5C9.06748 8.5 7.50048 10.067 7.50048 12C7.50048 13.933 9.06748 15.5 11.0005 15.5Z"
                    fill="currentColor"
                />
            </svg>
        ),
    },
];

const Sidebar = () => {
    const semidark = useSelector((state: IRootState) => state.themeConfig.semidark);
    const themeConfig = useSelector((state: IRootState) => state.themeConfig);
    const location = useLocation();
    const dispatch = useDispatch();
    const { hasPermission, hasAnyPermission } = usePermission();

    useEffect(() => {
        if (window.innerWidth < 1024 && themeConfig.sidebar) {
            dispatch(toggleSidebar());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    const visibleItems = NAV_ITEMS.filter((i) => {
        if (i.anyOf) return hasAnyPermission(i.anyOf);
        if (i.permission) return hasPermission(i.permission);
        return true;
    });

    return (
        <div className={semidark ? 'dark' : ''}>
            <nav
                className={`sidebar fixed min-h-screen h-full top-0 bottom-0 w-[260px] shadow-[5px_0_25px_0_rgba(94,92,154,0.1)] z-50 transition-all duration-300 ${semidark ? 'text-white-dark' : ''}`}
            >
                <div className="bg-white dark:bg-surface-card h-full">
                    <div className="flex justify-between items-center px-4 py-3">
                        <NavLink to="/apps" className="main-logo flex items-center shrink-0">
                            <img className="h-10 ml-[5px] flex-none dark:hidden" src="/assets/images/logo-color.webp" alt="Capital Cloud" />
                            <img className="h-10 ml-[5px] flex-none hidden dark:block" src="/assets/images/logo-white.webp" alt="Capital Cloud" />
                        </NavLink>

                        <button
                            type="button"
                            className="collapse-icon w-8 h-8 rounded-full flex items-center hover:bg-gray-500/10 dark:hover:bg-surface-hover dark:text-white-light transition duration-300 rtl:rotate-180"
                            onClick={() => dispatch(toggleSidebar())}
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 m-auto">
                                <path d="M13 19L7 12L13 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path opacity="0.5" d="M16.9998 19L10.9998 12L16.9998 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    </div>

                    <PerfectScrollbar className="h-[calc(100vh-80px)] relative">
                        <ul className="relative font-semibold space-y-0.5 p-4 py-0">
                            {visibleItems.map((item) => (
                                <li key={item.to} className="menu nav-item">
                                    <NavLink to={item.to} end={item.end} className="nav-link group">
                                        <div className="flex items-center">
                                            {item.icon}
                                            <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">{item.label}</span>
                                        </div>
                                    </NavLink>
                                </li>
                            ))}
                        </ul>
                    </PerfectScrollbar>
                </div>
            </nav>
        </div>
    );
};

export default Sidebar;
